<!--
  Bulk Resend Modal Template
  ==========================

  Admin-only modal for bulk resending form entry emails.
  Stage 1: JSON ids input and delivery mode selection.
  Stage 2: Progress bar with per-entry status list.
-->

<ion-header>
  <ion-toolbar color="primary">
    <ion-title>Bulk Resend Emails</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()" [disabled]="isRunning">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <!-- Stage 1: Input -->
  <ng-container *ngIf="!hasRun">
    <ion-item lines="none" class="ion-no-padding">
      <ion-label position="stacked">Form entry ids (separated by commas or new lines)</ion-label>
      <ion-textarea
        [(ngModel)]="idsJson"
        rows="6"
        placeholder="near_miss_report-123, hot_work_permit-456"
        class="ids-textarea">
      </ion-textarea>
    </ion-item>

    <ion-text color="danger" *ngIf="parseError">
      <p class="parse-error">{{ parseError }}</p>
    </ion-text>

    <ion-item lines="none" class="ion-no-padding ion-margin-top">
      <ion-label position="stacked">Delivery mode</ion-label>
      <ion-segment [(ngModel)]="mode" class="ion-margin-top">
        <ion-segment-button value="pdf">
          <ion-icon name="document-attach-outline"></ion-icon>
          <ion-label>Email with PDF</ion-label>
        </ion-segment-button>
        <ion-segment-button value="html">
          <ion-icon name="mail-outline"></ion-icon>
          <ion-label>Email in Body</ion-label>
        </ion-segment-button>
      </ion-segment>
    </ion-item>

    <ion-item lines="none" class="ion-no-padding">
      <ion-icon name="information-circle-outline" slot="start" color="medium"></ion-icon>
      <ion-label class="ion-text-wrap">
        <p>Emails are sent to the standard recipients configured for each form, one entry at a time.</p>
      </ion-label>
    </ion-item>

    <ion-button expand="block" class="ion-margin-top" (click)="start()">
      <ion-icon name="send-outline" slot="start"></ion-icon>
      Start Resend
    </ion-button>
  </ng-container>

  <!-- Stage 2: Progress -->
  <ng-container *ngIf="hasRun">
    <ion-progress-bar [value]="progressValue" [color]="failedCount > 0 ? 'warning' : 'primary'"></ion-progress-bar>

    <div class="progress-summary">
      <ion-text>
        <p class="progress-counts">
          {{ processedCount }} / {{ items.length }} processed
          &nbsp;&bull;&nbsp; <ion-text color="success">{{ successCount }} sent</ion-text>
          &nbsp;&bull;&nbsp; <ion-text color="danger">{{ failedCount }} failed</ion-text>
          &nbsp;&bull;&nbsp; {{ remainingCount }} left
        </p>
      </ion-text>
    </div>

    <!-- Per-entry status list -->
    <ion-list lines="full" class="status-list">
      <ion-item *ngFor="let item of items">
        <!-- Status icon -->
        <ion-spinner *ngIf="item.status === 'processing'" name="circular" slot="start" class="status-spinner"></ion-spinner>
        <ion-icon *ngIf="item.status === 'pending'" name="hourglass-outline" color="medium" slot="start"></ion-icon>
        <ion-icon *ngIf="item.status === 'success'" name="checkmark-circle" color="success" slot="start"></ion-icon>
        <ion-icon *ngIf="item.status === 'failed'" name="close-circle-outline" color="danger" slot="start"></ion-icon>

        <ion-label class="ion-text-wrap">
          <h3 class="entry-id">{{ item.id }}</h3>
          <p *ngIf="item.status === 'failed'" class="entry-error">{{ item.error }}</p>
        </ion-label>
      </ion-item>
    </ion-list>

    <!-- Run controls -->
    <ion-button
      *ngIf="isRunning"
      expand="block"
      color="medium"
      fill="outline"
      class="ion-margin-top"
      (click)="requestCancel()"
      [disabled]="cancelRequested">
      {{ cancelRequested ? 'Stopping after current entry...' : 'Stop' }}
    </ion-button>

    <ng-container *ngIf="!isRunning">
      <ion-button
        *ngIf="failedCount > 0"
        expand="block"
        color="warning"
        fill="outline"
        class="ion-margin-top"
        (click)="copyFailedIds()">
        <ion-icon name="clipboard-outline" slot="start"></ion-icon>
        Copy Failed Ids
      </ion-button>

      <ion-button expand="block" fill="outline" class="ion-margin-top" (click)="reset()">
        <ion-icon name="refresh-outline" slot="start"></ion-icon>
        New Bulk Resend
      </ion-button>

      <ion-button expand="block" class="ion-margin-top" (click)="close()">
        Close
      </ion-button>
    </ng-container>
  </ng-container>
</ion-content>
